import { createContext, useContext, useCallback, useRef, useState } from 'react';

const LiveRegionContext = createContext(null);

export const useLiveAnnounce = () => {
  const ctx = useContext(LiveRegionContext);
  if (!ctx) throw new Error('useLiveAnnounce must be used within LiveRegionProvider');
  return ctx;
};

export const LiveRegionProvider = ({ children }) => {
  const [message, setMessage] = useState('');
  const timeoutRef = useRef(null);

  const announce = useCallback((text) => {
    setMessage('');
    clearTimeout(timeoutRef.current);
    timeoutRef.current = setTimeout(() => setMessage(text), 50);
  }, []);

  return (
    <LiveRegionContext.Provider value={announce}>
      {children}
      <div role="status" aria-live="polite" aria-atomic="true" className="sr-only">
        {message}
      </div>
    </LiveRegionContext.Provider>
  );
};
